"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const BioPhChTabs_vue_1 = __importDefault(require("@becrop/components/Results/Common/BioPhChTabs.vue"));
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const CategoryStatus_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/CategoryStatus.vue"));
const ProjectsList_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/ProjectsList.vue"));
const ProjectSelector_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/ProjectSelector.vue"));
const CollapseAllControl_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/CollapseAllControl.vue"));
const GuideTeaser_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/GuideTeaser.vue"));
const CustomerSwitcher_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/CustomerSwitcher.vue"));
const OptimalRangeLegend_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/OptimalRangeLegend.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let MapSideBarPanelMetrics = class MapSideBarPanelMetrics extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.collapseAll = false;
        this.metricToSearch = '';
        this.metricComparativeToSearch = '';
        this.phChMetricToSearch = '';
        this.phChComparativeMetricToSearch = '';
        this.eventTracker = new EventTracker_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    onSearchMetric(metricName) {
        this.metricToSearch = metricName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        this.eventTrackerListener('searchMetrics', this.metricToSearch);
    }
    onSearchComparativeMetric(metricName) {
        this.metricComparativeToSearch = metricName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
    onSearchPhChMetric(metricName) {
        this.phChMetricToSearch = metricName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
    onSearchPhChComparisonMetric(metricName) {
        this.phChComparativeMetricToSearch = metricName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
    get metricBlocks() {
        if (this.mode === 'single') {
            if (this.dimension === 'bio') {
                return this.mainProjectDelivery.bioBlocks.filter((c) => c.metrics.length > 0);
            }
            if (this.dimension === 'phch') {
                return this.mainProjectDelivery.phchBlocks.filter((c) => c.metrics.length > 0);
            }
        }
    }
    metricBlocksVS(p) {
        if (this.mode === 'vs') {
            if (this.dimension === 'bio') {
                if (p === 'main') {
                    return this.comparisonReport.mainHighBioBlocks;
                }
                else {
                    return this.comparisonReport.secondaryHighBioBlocks;
                }
            }
            else {
                if (p === 'main') {
                    return this.comparisonReport.mainHighPhChBlocks;
                }
                else {
                    return this.comparisonReport.secondaryHighPhChBlocks;
                }
            }
        }
    }
    get abstractMetric() {
        if (this.mode === 'single') {
            if (this.dimension === 'bio') {
                return this.metric;
            }
            if (this.dimension === 'phch') {
                return this.phchMetric;
            }
        }
        else {
            if (this.dimension === 'bio') {
                return this.metricComparison;
            }
            if (this.dimension === 'phch') {
                return this.metricPhChComparison;
            }
        }
    }
    noPhChCTAClick() {
        window.location.href = 'mailto:support@becrop.com';
    }
    get onlyComparisonProjects() {
        return this.mainProjectsList.filter((p) => p.project_type !== 'rate' && p.project_type !== 'farm');
    }
    switchDimension(k) {
        this.$emit('switchDimension', k);
    }
    // @Debounce(100) Testing this comment in case is the reason of too late
    updateMetric(m) {
        this.$emit('updateMetric', m);
    }
    updatePhChMetric(m) {
        this.$emit('updatePhChMetric', m);
    }
    updateComparisonMetricFromMain(m) {
        this.$emit('updateComparisonMetric', m, 'main');
    }
    updateComparisonMetricFromSecondary(m) {
        this.$emit('updateComparisonMetric', m, 'secondary');
    }
    updatePhChComparisonMetricFromMain(m) {
        this.$emit('updatePhChComparisonMetric', m, 'main');
    }
    updatePhChComparisonMetricFromSecondary(m) {
        this.$emit('updatePhChComparisonMetric', m, 'secondary');
    }
    updateMainProject(p) {
        this.$emit('updateMainProject', p);
    }
    updateSecondaryProject(p) {
        this.$emit('updateSecondaryProject', p);
    }
    deployDoblePanel() {
        this.$emit('deployDoblePanel');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], MapSideBarPanelMetrics.prototype, "mainProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], MapSideBarPanelMetrics.prototype, "secondaryProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "secondaryProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "metricAgInsights", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "phchMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "comparisonReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "metricComparison", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "metricPhChComparison", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelMetrics.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'bio' })
], MapSideBarPanelMetrics.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarPanelMetrics.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelMetrics.prototype, "currentSubclient", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelMetrics.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelMetrics.prototype, "theme", void 0);
MapSideBarPanelMetrics = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: bmk_ui_framework_1.Search,
            Separator: bmk_ui_framework_1.Separator,
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            ProjectSelector: ProjectSelector_vue_1.default,
            CategoryStatus: CategoryStatus_vue_1.default,
            CheckBox: bmk_ui_framework_1.CheckBox,
            BioPhChTabs: BioPhChTabs_vue_1.default,
            Loading: bmk_ui_framework_1.Loading,
            CollapseAllControl: CollapseAllControl_vue_1.default,
            ViewZero: bmk_ui_framework_1.ViewZero,
            PhChIcon: bmk_ui_framework_1.PhChIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            ProjectsList: ProjectsList_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            CustomerSwitcher: CustomerSwitcher_vue_1.default,
            OptimalRangeLegend: OptimalRangeLegend_vue_1.default,
            GuideTeaser: GuideTeaser_vue_1.default
        },
    })
], MapSideBarPanelMetrics);
exports.default = MapSideBarPanelMetrics;
